export enum TimeIntervalType {
  TODAY = 'today',
  THIS_WEEK = 'this_week',
  THIS_MONTH = 'this_month',
  MONTH_TO_DATE = 'month_to_date',
  CUSTOM = 'custom',
}
